import React  from 'react';
import PropTypes from 'prop-types';

import StartEnd from "core/gd-ui/select-start-end/select-start-end";

export default function StartEndDateInList(props) {

    return (
        <StartEnd renderValue='text-13'
                  type="list"
                  value={{start: props.item.startDate, end: props.item.endDate}}
                  placeholder="Start / End "
                  onChange={props.onChange}
                  deleteButton={_.isNil(props.deleteButton) ? true : props.deleteButton}
                  btnNoValue={props.btnNoValue}
                  btnNoValueLabel={props.btnNoValueLabel}
                  dateFormat={_.isNil(props.dateFormat) ? "MMM DD" : props.dateFormat}
                  popoverAttachment="top right"
                  popoverTargetAttachment="bottom right"
                  disabled={props.disabled}/>
    );
}

StartEndDateInList.propTypes = {
    item: PropTypes.object,
    disabled: PropTypes.bool,
    dateFormat: PropTypes.string,
    deleteButton: PropTypes.bool,

    onChange: PropTypes.bool
};
